import { Box, IconButton } from '@mui/material'
import { Dismiss12Regular } from '@/components/Icon'
import Tooltip from '@/components/Tooltip'
import styles from './index.module.scss'

export default function AttachmentComposerChipImage({ file, previewUrl, uploadState, onRemove, onOpenImageGallery }) {
  const stateClass = uploadState === 'error' ? ` ${styles.fileChipUploadError}` : ''
  return (
    <Box className={`${styles.fileChip} ${styles.fileChipImageOnly}${stateClass}`}>
      <Box className={styles.fileChipThumbWrap}>
        <Tooltip text="Remove" placement="top">
          <IconButton
            type="button"
            size="small"
            className={styles.fileRemoveOverThumb}
            onClick={(e) => {
              e.stopPropagation()
              onRemove()
            }}
            aria-label={`Remove ${file.name}`}
          >
            <Dismiss12Regular className={styles.fileRemoveOverThumbIcon} aria-hidden />
          </IconButton>
        </Tooltip>
        <Box className={styles.fileIconPreview}>
          {onOpenImageGallery ? (
            <button
              type="button"
              className={styles.fileThumbOpen}
              onClick={(e) => {
                e.stopPropagation()
                onOpenImageGallery()
              }}
              aria-label={`Open full screen preview of ${file.name}`}
            >
              <img src={previewUrl} alt="" className={styles.fileThumb} />
            </button>
          ) : (
            <img src={previewUrl} alt="" className={styles.fileThumb} />
          )}
        </Box>
      </Box>
    </Box>
  )
}
